import GhostLogoV2 from './GhostLogoV2';
import GhostLogoV2EqualHeight from './GhostLogoV2EqualHeight';
export { GhostLogoV2, GhostLogoV2EqualHeight };
